import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ImageDetail } from '@bookinglab/govbook-ui';
import { NavLink } from '@bookinglab/govbook-ui/layout';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import { DatastoreService } from '../../services';

@Component({
	selector: 'app-header',
	standalone: true,
	imports: [CommonModule, GbHeaderComponent],
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
	constructor(private datastoreService: DatastoreService) {}

	login() {
		window.open(
			'https://chapter.registrars.staging.bookinglab.co.uk/lincolnshire-staging/37002',
			'_blank'
		);
	}

	isAdmin() {
		return this.datastoreService.adminJourney;
	}
	imageDetail: ImageDetail = {
		alt: 'Lincolnshire County Council',
		src: 'lincolnshire-logo.svg',
	};

	navigation: NavLink[] = [
		{
			text: 'Types of ceremonies',
			url: 'https://www.lincolnshire.gov.uk/homepage/191/ceremony-types',
		},
		{
			text: 'Marriages and civil partnerships',
			url: 'https://www.lincolnshire.gov.uk/marriage-civil-partnerships',
		},
		{
			text: 'Lincolnshire County Council homepage',
			url: 'https://www.lincolnshire.gov.uk/',
		},
	];

	search(term: string) {
		const formatted = term.trim().replace(/\s+/g, '+');
		const url = `https://www.lincolnshire.gov.uk/site-search/results/?q=${formatted}`;
		window.location.href = url;
	}
}
